import { NgModule } from '@angular/core';
import { UiModule } from '@shared/ui';
import { CompatModalsComponent } from './compat-modals.component';

@NgModule({
  imports: [UiModule],
  declarations: [CompatModalsComponent],
  entryComponents: [CompatModalsComponent],
})
export class CompatModalsModule {}



// WEBPACK FOOTER //
// ./src/compat/compat-modals.module.ts